<template>
  <div class="text-block text-editor container add-padding">
    <div class="text-editor">
      <div>
        <strong>About</strong><br/>
        François Lemmens<br/>
      </div>
    </div>
  </div>
</template>

<script>

export default {
}

</script>

<style scoped>

.container.add-padding {
  width: calc(100% - 40px);
}

.text-block {
  margin-top: 20px;
  margin-left: 80px;
  max-width: 844px;
  overflow: hidden;
  text-align: justify;
  color: #707070;
  font-size: 15px;
}

.text-editor, .text-block, .text-editor p, .text-block p {
  line-height: 1.5em;
  margin-bottom: 1.5em;
}

.text-editor, .text-block {
  font-family: "Helvetica Neue",Helvetica,Arial,"Lucida Grande",sans-serif;
  letter-spacing: 0;
}

a:hover {
  border-bottom: none;
}

.text-editor a, .text-block a {
  color: inherit;
  text-decoration: none;
  font-weight: normal;
  border-bottom: 1px solid;
}

a:active, a:hover {
  outline: 0;
}

a {
  transition: color 200ms ease, opacity 200ms ease;
  outline: none !important;
  background: 0 0;
}

</style>
